// extracted by mini-css-extract-plugin
export default {"modalDialog":"styles_modalDialog__DLo2b","modalContent":"styles_modalContent__QwO8A"};